<template>
  <div>
    <div class="su-top box-sizing">

        <div class="trans-tip" v-if="userInfo.ustate==0">
            <label class="c-tip"  @click="$router.push('/tabs/flowRecharge')">
                <el-alert style="background: #c30;color:#fff;"  title="重要提醒：因业务风险，您无法使用我司普通域名转换，被限制只能使用专属域名（备注安全）+自有域名，详细咨询客服" type="warning" show-icon :closable="false"></el-alert>
            </label>
        </div>
<!--      <div class="trans-tip">-->
<!--        <label class="c-tip" @click="$router.push('/tabs/flowRecharge')">-->
<!--          <el-alert  title="因服务器维护成本高，请购买访问包，否则可能存在广告，点击这里购买" type="warning" show-icon :closable="false"></el-alert>-->
<!--        </label>-->
<!--      </div>-->
      <div class="su-item" style="margin-top: 20px;">
        <span class="lab">分类：</span>
        <span class="opt">
          <el-select v-model="urlClass" clearable placeholder="请选择分类" class="inp">
              <el-option v-for="item in classOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </span>
        <span class="lab">时间：</span>
        <span class="opt">
          <el-date-picker
              v-model="timeGroup"
              type="daterange"
              unlink-panels
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </span>
      </div>
      <div class="su-item">
        <span class="lab">关键词：</span>
        <span class="opt"><el-input class="inp" placeholder="请输入原链接域名或备注" v-model="keyword" clearable></el-input></span>
        <span class="lab"></span>


      </div>

        <div class="flex-row ">
            <el-button type="primary" @click="getUrlList">搜索</el-button>
            <el-button type="success" @click="handleExportData">导出为Excel</el-button>
            <el-button type="primary" @click="loadingWordDialog=true">设置跳转loading文字</el-button>
            <el-button type="primary" @click="limitDialog=true">设置限制</el-button>
        </div>
      <div class="btn-features" style="margin-top: 10px;">
        <el-button type="success" @click="$router.push('/tabs/index')" style="font-weight: bolder;">+创建短网址</el-button>
        <el-button type="success" @click="$router.push('/tabs/batchConversion')" style="font-weight: bolder;">+批量创建短网址</el-button>
        <el-button type="primary" @click="classDialog=true">批量设置分类</el-button>
        <el-button type="warning" @click="daoru_yuan">监控原链接是否拦截</el-button>
        <el-button type="primary" @click="oldDialog=true">批量替换原链接</el-button>
        <el-button type="warning" @click="replaceWordDialog=true">批量替换链接字符</el-button>

        <el-popconfirm title="确定删除选中的链接吗？删除后不可恢复！" @confirm="delLinks()" style="margin-left: 10px">
          <el-button type="danger" slot="reference">删除选中</el-button>
        </el-popconfirm>
        <el-button type="success" @click="$router.push('/tabs/userLabel')" style="margin-left: 10px;">分类管理</el-button>


      </div>
    </div>
    <div class="su-mid box-sizing">
      <div>
        <label class="c-tip" >
           <router-link to="/tabs/ckUrlList"><el-alert  title=" 检测原链接是否被封，点击这里 " type="warning" show-icon :closable="false"></el-alert></router-link>
        </label>
      </div>
      <el-table v-loading="isLoading3" :data="tableData" empty-text="暂无数据" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="42"></el-table-column>
        <el-table-column label="添加日期" width="110">
          <template slot-scope="scope">
            <div class="lim text-align exc_color" v-if="scope.row.is_exclusive">
              <i class="iconfont iconhuiyuanjulebu"></i>专属域名
            </div>
            <div class="lim">{{ scope.row.create_time }}</div>
          </template>
        </el-table-column>
        <el-table-column label="网址" >
          <template slot-scope="scope">
            <div class="lim">
              <div class="l">
                <span>原：</span>
                <a class="links" :href="scope.row.url" target="_blank">{{ scope.row.url }}</a>
              </div>
              <div class="r">
                <el-link type="primary" @click="showReplaceUrl(scope.row)">替换</el-link>
              </div>
            </div>
            <div class="lim">
              <div class="l">
                <span>短：</span>
                <a class="links" :href="scope.row.new_url" target="_blank">{{ scope.row.new_url }} <font  v-if="scope.row.loading_word!=''" style="color:#ccc;font-size:10px;">[{{ scope.row.loading_word}}]</font><font  v-if="scope.row.ip_limit_pv!=''" style="color:#ccc;font-size:10px;">限[{{ scope.row.ip_limit_pv}}]</font></a>


              </div>
              <div class="r">
                <el-link type="primary" @click="copyUrl(scope.row.new_url)">复制</el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="二维码" width="75" class-name="text-align">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="点击查看二维码" placement="top">
              <i class="icon iconfont iconerweima" @click="showQrCode(scope.row.new_url)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column width="95" label="PV" class-name="text-align">
          <template slot-scope="scope">
            <div style="text-align: left;">
              <span style="color:#999">今日：{{scope.row.pv}}</span> <br>
              累计：{{scope.row.pv_total}}


            </div>
          </template>

        </el-table-column>
        <el-table-column  label="IP" width="95" class-name="text-align">

          <template slot-scope="scope">
            <div style="text-align: left;">
              <span style="color:#999">今日：{{scope.row.ip}} </span><br>
              累计：{{scope.row.ip_total}}


            </div>
          </template>
        </el-table-column>
        <el-table-column label="分类" width="120" class-name="text-align">
          <template slot-scope="scope">
            <span v-if="scope.row.labelName" class="class"
                  @click="editClass(scope.row.id)">{{ scope.row.labelName }}</span>
            <i v-else class="class icon el-icon-edit-outline" @click="editClass(scope.row.id)"></i>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="120" class-name="text-align">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="点击修改备注" placement="top">
              <div class="link-mark" @click="editMark(scope.row)">{{ scope.row.mark }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="148">
          <template slot-scope="scope">
            <div class="text-center">
              <router-link class="opt-link" :to="'/tabs/manage/'+scope.row.id">管理</router-link>
              <router-link class="opt-link" :to="'/tabs/advanced/'+scope.row.id">高级功能</router-link><br>
              <router-link class="opt-link" :to="'/tabs/channel/'+scope.row.id">渠道管理</router-link>
              <a class="opt-link" :href="'/statistics/'+scope.row.id" target="_blank">数据统计</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagebar" v-show="total>0">
        <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :page-size="50"
                       @current-change="handleCurrentPage"></el-pagination>
      </div>
    </div>
    <!--查看二维码-->
    <el-dialog title="查看二维码" :visible.sync="qrCodeDialog" center :destroy-on-close="true" :modal-append-to-body="false"
               width="400px">
			<div class="flex-row flex-center mb10">
				<div  class="fs12 pad" :class="show_diy_qr?'':'bg_blue radius-10'"  @click="show_diy_qr=0">
					
					普通</div>
				<div class="fs12 pad" :class="show_diy_qr?'bg_blue radius-10':''" @click="show_diy_qr=1;show_diy_qrlogo()">自定义</div>
			</div>   
            <div class="qrbox22"  v-show="show_diy_qr!=1">
                <div class="link-qr-code" ref="qrCodeDiv"></div>
            </div>
			
			<div v-show="show_diy_qr==1" class="flex-center flex-column" ref="qrCodeDiv2">
			      <vue-qr 
			        :text="codeText"    
			        :size="280"
			        :margin="20"
			        colorDark="#333"
			        backgroundColor="#fff"
			        :logoSrc="lgoImg"
			        logoScale="0.21"
			        logoMargin="25px"
			      ></vue-qr>
				  <div class="pad">*在个人信息页面上传logo图片，即可自动生成带logo的二维码，也可点击下面继续添加
						<el-upload
							action=""
							:http-request="upload_img"
							:show-file-list="false"
							accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF"
							:on-success="null">
							<div class="pad">
						  <span class="border-gray pad510 bg_gray_eee radius-5 fs12 ml10">+添加logo</span>
						  </div>
						</el-upload>
						
						<div class="flex-row">
							<div class="flex-column mr10 flex-center" v-for="logo in logo_list">
								<img :src="logo"  class="pic-50 radius-5 " @click="lgoImg=logo">
								<div  title="点击删除" @click="logo_list.remove(logo);del_qrlogos()" class="fs-12">删除</div>
							</div>
						</div>
						
				  </div>
			    </div>
      <span slot="footer">
                <el-button type="primary" @click="savePic(show_diy_qr)">下载二维码</el-button>
            </span>
    </el-dialog>
    <!--设置分类-->
    <el-dialog title="设置分类" :visible.sync="classDialog" center width="400px">
            <span>
                <el-select v-model="selClassID" clearable placeholder="请选择分类" style="width: 100%">
                        <el-option v-for="item in classOptions" :key="item.id" :label="item.label"
                                   :value="item.id"></el-option>
                </el-select>
            </span>
      <span slot="footer">
                <el-button @click="classDialog=false">取消</el-button>
                <el-button type="primary" @click="saveClass">确定</el-button>
            </span>
    </el-dialog>
    <!--批量替换原链接-->
    <el-dialog title="批量替换原链接" :visible.sync="oldDialog" center width="400px">
            <span>
<!--                <el-input  v-model="url" placeholder="请填写新替换的链接"></el-input>-->
                <el-input v-model="url" clearable placeholder="请输入新链接"></el-input>
            </span>
      <span slot="footer">
                <el-button @click="oldDialog=false">取消</el-button>
                <el-button type="primary" @click="oldClass">确定</el-button>
            </span>
    </el-dialog>
    <!--域名备注-->
    <el-dialog title="设置备注" :visible.sync="markDialog" center width="400px">
            <span>
                <el-input v-model="urlMark" clearable maxlength="20" placeholder="请输入备注"></el-input>
            </span>
      <span slot="footer">
                <el-button @click="markDialog=false">取消</el-button>
                <el-button type="primary" @click="saveMark">确定</el-button>
            </span>
    </el-dialog>
      <!--设置限制提示-->
      <el-dialog title="设置限制" :visible.sync="limitDialog" center width="400px">
          <div class="flex-row item-center">
                <span class="w150px">IP限制次数：</span>
                <el-input v-model="ip_limit_pv"  maxlength="20" placeholder="请输入限制次数"></el-input>
            </div>
          <div class="fs12 ml100 mt6">如果超出这个次数，对应IP的访问会显示 "404访问受限"</div>
          <div class="flex-row item-center mt10">
              <span class="w150px">总限制次数：</span>
              <el-input v-model="limit_pv"  maxlength="20" placeholder="请输入限制次数"></el-input>
          </div>
          <div class="fs12 ml100 mt6">如果超出这个次数，链接所有访问都显示 "404访问受限"</div>
          <div class="flex-row item-center mt10">
              <span class="w150px">限制提示：</span>
                <el-input v-model="limit_pv_tips"  maxlength="20" placeholder="请输入限制提示"></el-input>

            </div>
          <div class="fs12 ml100 mt6">默认提示“访问受限”{{selUrlID}}</div>
          <div class="fs12  mt6 red" v-if="selUrlID==''">您未勾选单挑，则变更全部，请谨慎操作</div>

          <span slot="footer">
                <el-button @click="limitDialog=false">取消</el-button>
                <el-button type="primary" @click="saveLimit">确定</el-button>
            </span>
      </el-dialog>
    <!--链接导出-->
    <el-dialog title="链接导出" :visible.sync="exportDialog" width="980px">
      <div class="exp_box">
        <div class="exp_title">导出条件</div>
        <div class="exp_head">
          <span class="lab">时间：</span>
          <el-date-picker
              v-model="expTimeGroup"
              type="daterange"
              unlink-panels
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
          <span class="lab">分类：</span>
          <el-select v-model="expUrlClass" clearable placeholder="请选择分类" class="sel">
            <el-option v-for="item in classOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
          <span class="lab">专属域名：</span>
          <el-select v-model="exclusive" clearable placeholder="请选择专属域名" class="sel" :loading="isLoading1"
                     @visible-change="getDomainList">
            <el-option v-for="item in excOptions" :key="item.id" :label="item.domain" :value="item.id"></el-option>
          </el-select>
          <el-button class="inp" type="primary" :loading="isLoading4" @click="addExport">导出</el-button>
        </div>
        <div class="exp_title">
          <span>导出记录</span>
          <el-button type="text" size="small" style="float: right" @click="getExportList">刷新状态</el-button>
        </div>
        <el-table v-loading="isLoading2" :data="exportData" empty-text="暂无数据" style="width: 100%">
          <el-table-column prop="create_time" label="创建时间" width="150" class-name="text-align"></el-table-column>
          <el-table-column label="时间段" class-name="text-align" width="230">
            <template slot-scope="scope">
              <span v-if="scope.row.start_time!==''">{{ scope.row.start_time }} 至 {{ scope.row.end_time }}</span>
              <span v-else>全部</span>
            </template>
          </el-table-column>
          <el-table-column prop="label" label="分类" width="180" class-name="text-align"></el-table-column>
          <el-table-column prop="exclusive" label="专属域名" width="180" class-name="text-align"></el-table-column>
          <el-table-column label="状态" width="80" class-name="text-align">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.status==='0'" effect="dark" content="正在生成" placement="top">
                <i class="el-icon-loading"></i>
              </el-tooltip>
              <font v-else-if="scope.row.status==='1'" color="green">已完成</font>
              <el-tooltip v-else effect="dark" :content="scope.row.fail_reason" placement="top">
                <font color="red">失败</font>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" class-name="text-align">
            <template slot-scope="scope">
              <el-popconfirm title="确定删除吗？删除后不可恢复！" @confirm="delExport(scope.row.id)" style="margin-right: 10px">
                <el-button type="danger" slot="reference" size="small" icon="el-icon-delete"></el-button>
              </el-popconfirm>
              <el-button type="primary" size="small" icon="el-icon-download" :disabled="scope.row.status!=='1'"
                         @click="saveExcel(scope.row.cloud_file)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagebar" v-show="expTotal>0">
          <el-pagination background layout="total, prev, pager, next, jumper" :total="expTotal"
                         @current-change="handleExpCurrentPage"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!--域名替换-->
    <el-dialog title="域名替换" :visible.sync="replaceDialog" center width="400px">
            <span class="replace">
                <div class="item">
                    <div class="l">原链接：</div>
                    <div class="r"><el-input v-model="orgUrl" readonly placeholder="原链接"></el-input></div>
                </div>
                <div class="item"></div>
                <div class="item">
                    <div class="l">新链接：</div>
                    <div class="r"><el-input v-model="newUrl" clearable placeholder="请输入新链接"></el-input></div>
                </div>
            </span>
      <span slot="footer">
                <el-button @click="replaceDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading5" @click="replaceUrl">确定</el-button>
            </span>
    </el-dialog>
    <!--字符替换-->
    <el-dialog title="原链接字符替换" :visible.sync="replaceWordDialog" center width="400px">
            <span class="replace">
                <div class="item">
                    <div class="l">原字符：</div>
                    <div class="r"><el-input v-model="old_word"  placeholder="原字符"></el-input></div>
                </div>
                <div class="item"></div>
                <div class="item">
                    <div class="l">新字符：</div>
                    <div class="r"><el-input v-model="new_word"  placeholder="请输入新字符"></el-input></div>
                </div>
            </span>
      <span slot="footer">
                <el-button @click="replaceWordDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading5" @click="replaceWord">确定</el-button>
            </span>
    </el-dialog>
    <el-dialog title="设置loading文字" :visible.sync="loadingWordDialog" center width="500px">
            <span class="replace">
                <div class="item">
                    <div class="l" style="width:120px;">顶部标题：</div>
                    <div class="r"><el-input v-model="loading_word"  placeholder="默认loading"></el-input></div>
                </div>
                <div class="item" style="margin-top:15px;">
                    <div class="l" style="width:120px;">网页描述：</div>
                    <div class="r"><el-input v-model="loading_desc"  placeholder="分享了一个链接给您"></el-input></div>
                </div>
                <div class="item"></div>

            </span>
      <span slot="footer">
                <el-button @click="loadingWordDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading7" @click="loadingWord">确定</el-button>
            </span>
    </el-dialog>
      <el-dialog title="温馨提示"  center width="500px">
            <div>去实名认证</div>
      </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import VueQr from 'vue-qr'


Array.prototype.remove = function(val) { 
var index = this.indexOf(val); 
if (index > -1) { 
this.splice(index, 1); 
} 
};

export default {
  name: "ShortUrlList",
  components:{VueQr},
  data() {
    return {
		
      userInfo:{},
	  logo_list:[],
      isVip: false,
	  show_diy_qr:0,
	  codeText: 'https://www.baidu.com/',
	  lgoImg: '',//require('./../../assets/images/logo.png')
      urlClass: "",
      expUrlClass: "",
      keyword: "",
      total: 0,
      expTotal: 0,
      currentPage: 1,
      expCurrentPage: 1,
      timeGroup: [],
      expTimeGroup: [],
      classOptions: [],
      excOptions: [],
      tableData: [],
      exportData: [],
      multipleSelection: [],
      qrCodeDialog: false,
      classDialog: false,
      oldDialog:false,
      markDialog: false,
      limitDialog: false,
      limit_pv:'0',
        ip_limit_pv:'0',
        limit_pv_tips:'',


      exportDialog: false,
      replaceDialog: false,
      replaceWordDialog:false,
      loadingWordDialog:false,
      selClassID: "",
      url:"",
      selUrlID: "",
      btnLoading: false,
      urlMark: "",
      exclusive: "",
      isLoad: true,
      isLoads: false,
      isLoading1: false,
      isLoading2: false,
      isLoading3: false,
      isLoading4: false,
      isLoading5: false,
      isLoading6: false,
      isLoading7: false,
      orgUrl: "",
      newUrl: "",
      old_word:"",
      new_word:"",
      loading_word:'',
      loading_desc:'',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  mounted() {
      var $this=this;
    const token = this.$storeLocal.get('token');
    const user_info = this.$storeLocal.get('userInfo');
    const times = Date.parse(new Date()) / 1000;

    if (token !== null && token !== '' && token !== undefined) {
      if (user_info.expire_date > times) {
        this.isVip = true;
      }
    }
    this.getUrlList();
    this.getClassList();


      this.userInfo=this.$common.userInfo;
      setTimeout(function(){
          $this.userInfo=$this.$common.userInfo;
		  $this.logo_list=$this.userInfo.qr_logo_list.split('|');
      },1000)
  },
  methods: {
    async getClassList() {
      const {ret, data} = await this.$api.urlLabel.getClassList();
      if (ret === 1000) {
        this.classOptions = data.list;
      }
    },
    async getUrlList() {
      this.isLoading3 = true;
      let start = 0;
      let end = 0;
      if (this.timeGroup === null) this.timeGroup = [];
      if (this.timeGroup.length === 2) {
        start = this.timeGroup[0];
        end = this.timeGroup[1];
      }
      const getData = {
        start: Number(start / 1000),
        end: Number(end / 1000),
        keyword: this.keyword,
        label: this.urlClass,
        p: this.currentPage,
      };
      const {ret, data} = await this.$api.shortUrl.list(getData);
      this.isLoading3 = false;
      if (ret === 1000) {
        this.total = Number(data.total);
        this.tableData = data.list;
      }
    },
    async saveClass() {
      if (this.selUrlID === "") {
        this.$message.error('请选择要更新分类的链接！');
        return;
      }
      const getData = {
        url_id: this.selUrlID,
        lab_id: this.selClassID
      };
      const {ret} = await this.$api.urlLabel.setUrlClass(getData);
      if (ret === 1000) {
        this.getUrlList();
        this.selUrlID = "";
        this.classDialog = false;
        this.$message.success('设置成功');
      }

    },
    async oldClass() {
      if (this.selUrlID === "") {
        this.$message.error('请替换的原链接！');
        return;
      }
      const getData = {
        url_id: this.selUrlID,
        lab_id: this.url
      };
      const {ret} = await this.$api.urlLabel.setUrlLinkClass(getData);
      if (ret === 1000) {
        this.getUrlList();
        this.selUrlID = "";
        this.classDialog = false;
        this.$message.success('设置成功');
      }

    },
    async saveMark() {
      if (this.selUrlID === "") {
        this.$message.error('出错了！刷新后试试看');
        return;
      }
      const getData = {
        ids: this.selUrlID,
        mark: this.urlMark,
      };
      const {ret} = await this.$api.shortUrl.saveMark(getData);
      if (ret === 1000) {
        await this.getUrlList();
        this.selUrlID = "";
        this.markDialog = false;
        this.$message.success('保存成功！');
      }
    },
      async saveLimit() {
          if (this.selUrlID === "") {
              //this.$message.error('出错了！刷新后试试看');
              //return;
          }
          const getData = {
              ids: this.selUrlID,
              limit_pv: this.limit_pv,
              ip_limit_pv: this.ip_limit_pv,
              limit_pv_tips: this.limit_pv_tips,
          };
          const {ret} = await this.$api.shortUrl.saveLimit(getData);
          if (ret === 1000) {
              await this.getUrlList();
              this.selUrlID = "";
              this.limitDialog = false;
              this.$message.success('保存成功！');
          }
      },
    async delLinks() {
      console.log('1111');
      const ids = this.selUrlID;
      console.log(ids);
      if (ids === '') {
        this.$message.error('请选择要删除的链接！');
        return;
      }
      const {ret} = await this.$api.shortUrl.delLink({ids: ids});
      if (ret === 1000) {
        this.$message.success('删除成功');
        this.selUrlID = "";
        await this.getUrlList();
      }
    },
    async getExportList() {
      this.isLoading2 = true;
      const {ret, data} = await this.$api.export.getList({p: this.expCurrentPage});
      this.isLoading2 = false;
      if (ret === 1000) {
        this.expTotal = Number(data['total']);
        this.exportData = data['list'];
      }
    },
    async getDomainList(val) {
      if (!val) return;
      if (this.isLoads) return;
      this.isLoading1 = true;
      const {ret, data} = await this.$api.exclusive.getUserList();
      this.isLoading1 = false;
      if (ret === 1000) {
        this.isLoads = true;
        this.excOptions = data.list;
      }
    },
    async addExport() {
      this.isLoading4 = true;
      let start = 0;
      let end = 0;
      if (this.expTimeGroup === null) this.expTimeGroup = [];
      if (this.expTimeGroup.length === 2) {
        start = this.expTimeGroup[0];
        end = this.expTimeGroup[1];
      }
      const getData = {
        start: Number(start / 1000),
        end: Number(end / 1000),
        exclusive: this.exclusive,
        label: this.expUrlClass,
      };
      const {ret} = await this.$api.export.addExport(getData);
      this.isLoading4 = false;
      if (ret === 1000) {
        await this.$alert('链接导出请求已提交，系统正在处理，请稍等5-10分钟！', '提示', {
          callback: () => {
            this.getExportList();
          }
        });
      }
    },
    async delExport(id) {
      console.log(id);
      if (!id) return;
      const {ret} = await this.$api.export.delExport({id: id});
      if (ret === 1000) {
        this.$message.success('删除成功');
        await this.getExportList();
      }
    },
    async replaceUrl() {
      const newUrl = this.newUrl;
      const isUrl = this.$common.isUrl(newUrl);
      if (!isUrl) {
        this.$message.error('请输入正确的链接');
        return;
      }
      const postData = {
        id: this.selUrlID,
        newUrl: newUrl,
      };
      this.isLoading5 = true;
      const {ret} = await this.$api.shortUrl.replaceUrl(postData);
      this.isLoading5 = false;
      if (ret === 1000) {
        this.selUrlID = '';
        this.replaceDialog = false;
        this.$message.success('替换成功！');
        await this.getUrlList();
      }
    },
    async replaceWord() {
      const new_word = this.new_word;
      const old_word = this.old_word;
      if (!old_word) {
        this.$message.error('请输入原字符');
        return;
      }
      if (!new_word) {
        this.$message.error('请输入新字符');
        return;
      }
      const postData = {
        id: this.selUrlID,
        old_word: old_word,
        new_word: new_word,
      };
      this.isLoading6 = true;
      const {ret} = await this.$api.shortUrl.replaceWord(postData);
      this.isLoading6 = false;
      if (ret === 1000) {
        this.selUrlID = '';
        this.replaceDialog = false;
        this.$message.success('替换成功！');
        await this.getUrlList();
      }
    },
    async loadingWord() {
      const loading_word = this.loading_word;
      const loading_desc = this.loading_desc;

      console.log('1111');
      const ids = this.selUrlID;
      console.log(ids);
      if (ids === '') {
        //this.$message.error('请先选择短网址！');
        //return;
      }

      if (!loading_word) {
        this.$message.error('请输入新字符');
        return;
      }
      const postData = {
        id: this.selUrlID,
        loading_word: loading_word,
        loading_desc: loading_desc,
      };
      this.isLoading6 = true;
      const {ret} = await this.$api.shortUrl.loadingWord(postData);
      this.isLoading6 = false;
      if (ret === 1000) {
        this.selUrlID = '';
        this.loadingWordDialog = false;
        this.$message.success('设置成功！');
        await this.getUrlList();
      }
    },
    handleSelectionChange(val) {
      if (val.length === 0) {
        return;
      }
      let ids = "";
      for (const item of val) {
        ids += item.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selUrlID = ids;
    },
    handleCurrentPage(val) {
      this.currentPage = val;
      this.getUrlList();
    },
    handleExpCurrentPage(val) {
      this.expCurrentPage = val;
      this.getExportList();
    },
    handleExportData() {
      this.exportDialog = true;
      if (this.isLoad) {
        this.isLoad = false;
        this.getExportList();
      }
    },
    async daoru_yuan() {
      const $this = this;
      this.$confirm('将短网址的原链接直接导入到监控列表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {ret} = await this.$api.monitorUrl.import();
        if (ret === 1000){
          $this.$message.success("导入成功！");
          this.$router.push({ path:'/tabs/ckUrlList'  })
        }
      });
    },
    editClass(id) {
      this.classDialog = true;
      this.selUrlID = id;
    },
    editMark(item) {
      this.markDialog = true;
      this.selUrlID = item.id;
      this.urlMark = item.mark;
    },
    showReplaceUrl(item) {
      if (this.isVip || item.is_exclusive) {
        this.selUrlID = item.id;
        this.orgUrl = item.url;
        this.replaceDialog = true;
      } else {
        this.$confirm('该功能为VIP专属功能，请升级VIP后使用', '提示', {
          confirmButtonText: '前往升级',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.$router.push('/tabs/vipRecharge');
        });
      }
    },
    copyUrl(txt) {
      const msg = this.$message;
      if (txt === '') {
        msg.error('复制失败！');
      }
      this.$copyText(txt).then(function (e) {
        console.log(e);
        msg.success('复制成功');
      }, function (e) {
        console.log(e);
        msg.error('复制失败！');
      });
    },
    showQrCode(txt) {
      if (txt === '') {
        this.$message.error('出错了！刷新试试看！');
        return;
      }
	  this.codeText=txt;
      this.qrCodeDialog = true;
      const $this = this;
      setTimeout(function () {
        $this.$refs.qrCodeDiv.innerHTML = '';
        new QRCode($this.$refs.qrCodeDiv, {
          text: txt,
          width: 400,
          height: 400,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
      }, 100);
    },
    savePic(type) {
		var myQrCode;
	  if(!type){
		   myQrCode = this.$refs.qrCodeDiv.getElementsByTagName('canvas');
		   let a = document.createElement('a');
		   a.href = myQrCode[0].toDataURL('image/png');
		   a.download = 'linkQrCode';
		   a.click();
	  }else{
		   myQrCode = this.$refs.qrCodeDiv2.getElementsByTagName('img');
		   let a = document.createElement('a');
		   a.href = myQrCode[0].src;
		   a.download = 'linkQrCode';
		   a.click();
	  }
      
     
    },
    saveExcel(url) {
      if (url === '') return;
      let a = document.createElement('a');
      a.href = url;
      a.download = 'linkExcel';
      a.click();
    },
	show_diy_qrlogo(){
		var $this=this;
		console.log($this.userInfo);
		$this.lgoImg=$this.userInfo.qr_logo;
	},
	async upload_img(file){
	  var $this=this;
	  this.$common.Upload(file,function(img){
	    console.log(img);
	    $this.$forceUpdate();
		$this.lgoImg=img;
	    $this.save_qrlogos(img);
	    
	  });
	},
	async save_qrlogos(img){
		 var $this=this;
		 $this.logo_list.push(img);
		 var dd=$this.logo_list.join('|');
		 const {ret} = await $this.$api.user.saveQrlogoList({qr_logo:dd});
		 if (ret === 1000){
		   this.$message.success("添加成功");
		 } 
	},
	async del_qrlogos(){
		 var $this=this;
		 var dd=$this.logo_list.join('|');
		 const {ret} = await $this.$api.user.saveQrlogoList({qr_logo:dd});
		 if (ret === 1000){
		   this.$message.success("添加成功");
		 } 
	}
	
  }
}
</script>

<style scoped>
.su-top {
  width: 100%;
  height: auto;
  padding: 20px;
}

.su-top .su-item {
  width: 100%;
  height: 40px;
  color: #666666;
  margin-bottom: 10px;
}

.su-top .su-item .lab {
  display: inline-block;
  width: 60px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: right;
  margin-right: 10px;
  vertical-align: top;
}

.su-top .su-item .opt {
  display: inline-block;
  width: 400px;
  height: 40px;
  vertical-align: top;
}

.su-top .su-item .inp {
  width: 350px;
}

.su-top .btn-features {
  width: 100%;
  height: 40px;
  margin-top: 30px;
}

.su-mid {
  width: 100%;
  padding: 0 20px;
}

.su-mid .lim {
  width: 100%;
  height: 24px;
}

.su-mid .lim .l {
  display: inline-block;
  width: 242px;
  height: 24px;
  overflow: hidden;
  vertical-align: top;
}

.su-mid .lim .l .links {
  display: inline-block;
  width: 214px;
  height: 24px;
  color: #409EFF;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
}

.su-mid .lim .l .links:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.su-mid .lim .r {
  display: inline-block;
  width: 28px;
  height: 24px;
  cursor: pointer;
  margin-left: 10px;
  vertical-align: top;
}

.su-mid .icon {
  cursor: pointer;
  font-size: 28px;
}

.su-mid .icon:hover {
  color: #409EFF;
}

.su-mid .class {
  color: #409EFF;
  cursor: pointer;
}

.pagebar {
  width: 100%;
  height: 52px;
  margin-top: 20px;
}

.link-qr-code {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}


.opt-link {
  color: #409EFF;
  margin-right: 5px;
  white-space: nowrap;
}

.link-mark {
  width: 100px;
  min-height: 23px;
}

.exp_box {
  width: 100%;
}

.exp_box .exp_title {
  width: 100%;
  height: auto;
  font-size: 14px;
  margin-bottom: 20px;
}

.exp_box .exp_head {
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
}

.exp_box .exp_head .lab {
  display: inline-block;
  width: auto;
  height: 40px;
  line-height: 40px;
  margin: 0 5px;
  vertical-align: top;
}

.exp_box .exp_head .sel {
  width: 160px;
}

.exp_box .exp_head .inp {
  margin-left: 10px;
}

.replace {
  width: 100%;
  height: auto;
}

.replace .item {
  width: 100%;
  height: 40px;
  line-height: 40px;
}

.replace .item .l {
  display: inline-block;
  width: 60px;
  height: 40px;
  vertical-align: top;
}

.replace .item .r {
  display: inline-block;
  width: 290px;
  height: 40px;
  vertical-align: top;
}

.exc_color {
  color: #f6ab16 !important;
}
</style>
